import type React from 'react';
import { css, styled } from 'styled-components';

import { BaseNotification, type BaseNotificationProps } from './Base.tsx';

type InlineNotificationProps = Omit<BaseNotificationProps, 'closeable' | 'onClick' | 'role'> & {
  spacer?: boolean;
  uncloseable?: boolean;
  fullWidth?: boolean;
};

const StyledNotification = styled(BaseNotification)<{ $spacer?: boolean; $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  ${({ $spacer }) =>
    $spacer &&
    css`
      margin-bottom: 24px;
    `};
`;

export const InlineNotification: React.FC<InlineNotificationProps> = ({ spacer, uncloseable, fullWidth, ...rest }) => (
  <StyledNotification {...rest} $spacer={spacer} $fullWidth={fullWidth} closeable={!uncloseable} />
);
